import src from "IMAGE";
export default { src, width: 338, height: 274, blurWidth: 0, blurHeight: 0};
